const AU_COMMUNICATIONS_TIME_ZONE = "Australia/Melbourne";
const NZ_COMMUNICATIONS_TIME_ZONE = "Pacific/Auckland";

function communicationsTimeZone(region) {
  return String(region || "AU").toUpperCase() === "NZ"
    ? NZ_COMMUNICATIONS_TIME_ZONE
    : AU_COMMUNICATIONS_TIME_ZONE;
}

/**
 * SMS / email timestamps in the admin Communications UI (Melbourne for AU, Auckland for NZ).
 */
function formatCommunicationsDateTime(value, region) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  const r = String(region || "AU").toUpperCase();
  const locale = r === "NZ" ? "en-NZ" : "en-AU";
  return d.toLocaleString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: communicationsTimeZone(r),
  });
}

function normalizeSmsProvider(provider) {
  return provider === "ClickSend" ? "ClickSend" : "HOB";
}

function smsStatusChipLabel(status) {
  const normalized = String(status || "Sent");
  const lower = normalized.toLowerCase();
  if (lower === "delivered") return "Delivered";
  if (lower === "failed") return "Failed";
  return "Sent";
}

module.exports = {
  communicationsTimeZone,
  formatCommunicationsDateTime,
  normalizeSmsProvider,
  smsStatusChipLabel,
};
